import { cardItems } from '@/mocks/homeData';

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 text-center mb-2">
          精选推荐
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          按照你的观影偏好，从海量片库中精选七大类优质内容
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 md:gap-5">
          {cardItems.slice(0, 7).map((card, idx) => (
            <div
              key={idx}
              className={`group rounded-lg overflow-hidden border border-background-300/40 bg-background-50/70 transition-all duration-300 hover:border-primary-500/30 ${
                idx === 0 ? 'sm:col-span-2 sm:row-span-1' : ''
              }`}
            >
              <div className={`relative overflow-hidden ${idx === 0 ? 'aspect-[2/1]' : 'aspect-[3/2]'}`}>
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  onError={(e) => {
                    (e.target as HTMLElement).parentElement!.style.display = 'none';
                  }}
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 text-xs font-medium bg-background-950/70 text-foreground-200 rounded-full">
                    {card.category}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm md:text-base font-semibold text-foreground-800 mb-1.5">
                  {card.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed">
                  {card.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}